import Styles from "./MainContent.module.scss";

interface Props {
  children: any;
}

export const MainContent = (props: Props) => {
  return <div className={Styles.mainContentContainer}>{props.children}</div>;
};
